import { showModal, hideModal } from 'actions/modal';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import ModalOuterContainer from 'components/shared/modals/generic/containers/ModalOuterContainer';
import { ERROR_MODAL } from 'constants/shared/modalTypes';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { formatMoney } from 'lib/utils';
import { useRegradeSubscription } from 'lib/hooks';
import useTranslate from 'lib/languages/useTranslate';
import { accountRolesLookup } from 'lib/constants';
import { trackCustomerIOEvent, identifyCustomerIO } from 'utils/customerIO';
import jwt_decode from 'jwt-decode';
import { CustomerIOEvent } from 'lib/type';

interface RegradeSubscriptionModalProps {
    newRole: string;
    currentRole: string;
}

const RegradeSubscriptionModal = ({
    newRole,
    currentRole,
}: RegradeSubscriptionModalProps) => {
    const dispatch = useDispatch();
    const {
        isLoading,
        isSuccess,
        error,
        handleSubmit,
        isUpgrade,
        currentCost,
        newCost,
    } = useRegradeSubscription(currentRole, newRole);

    const translate = useTranslate('pricePlan');
    const currentPricePlanName = accountRolesLookup[currentRole];
    const newPricePlanName = accountRolesLookup[newRole];

    const accessToken = localStorage.getItem('accessToken');
    const userData = jwt_decode(accessToken);

    useEffect(() => {
        const eventName = isUpgrade
            ? CustomerIOEvent.UPGRADE_PRODUCT
            : CustomerIOEvent.DOWNGRADE_PRODUCT;
        if (isSuccess) {
            trackCustomerIOEvent(eventName, {
                previous_plan: currentPricePlanName,
                new_plan: newPricePlanName,
            });
            identifyCustomerIO(userData.usernameV1, {
                product: newPricePlanName,
            });
            dispatch(hideModal());
        }
    }, [
        isSuccess,
        dispatch,
        isUpgrade,
        currentPricePlanName,
        newPricePlanName,
        userData.usernameV1,
    ]);

    useEffect(() => {
        if (error) {
            dispatch(
                showModal({
                    type: ERROR_MODAL,
                    onClose: () => dispatch(hideModal()),
                }),
            );
        }
    }, [error, dispatch]);

    return (
        <ModalOuterContainer handleSubmit={handleSubmit} isPosting={isLoading}>
            <div className="description">
                <Typography tag="h1">
                    {translate('confirmModal.titleText')}
                </Typography>
                <Typography>
                    {translate(
                        isUpgrade
                            ? 'confirmModal.upgradeDescription'
                            : 'confirmModal.downgradeDescription',
                        {
                            currentCost: `£${formatMoney(currentCost)}`,
                            newCost: `£${formatMoney(newCost)}`,
                            currentPricePlanName,
                            newPricePlanName,
                        },
                    )}
                </Typography>
            </div>
        </ModalOuterContainer>
    );
};

export default RegradeSubscriptionModal;
